<template>
    <div id='order'>
        <div class="body">
            <div class="pubw">
                <NavMenu />
                
                <div class="orderList">
                    <h2 class="h">{{title}}</h2>
                    <div class="emptyTips" v-show="orderPagiList.length<=0">
                        <span>暫無信息</span>
                    </div>
                    <div class="order" v-for="item in orderPagiList[currentPage-1]" :key="item.orderId">
                        <div class="info">
                            <div class="top">
                                <div class="orderNumber">
                                    <span class="el-icon-s-order"></span>
                                    <span>訂單編號：<span class="number">{{item.orderNumber}}</span></span>
                                </div>
                                <div class="status">
                                    <span :class="item.statusName=='已提交'?'submit':''">{{item.statusName}}</span>
                                </div>
                            </div>
                            <div class="middle">
                                <div class="start">
                                    <p>{{item.startPlace}}</p>
                                    <p class="">{{item.startPeople}}</p>
                                </div>
                                <div class="line">
                                    <span class="iconfont icon-zuobiaofill"></span>
                                    <div class="points">
                                        <span v-for="(item,index) in 23" :key="index"></span>
                                    </div>
                                    <span class="iconfont icon-biaoji"></span>
                                </div>
                                <div class="end">
                                    <p>{{item.endPlace}}</p>
                                    <p>{{item.endPeople}}</p>
                                </div>
                                <span class="status" :class="item.payState=='未付款'?'nopay':'okpay'">{{item.payState}}</span>
                            </div>
                            <div class="option">
                                <div class="pay" @click="pay(item.orderId)">
                                    <optionsButton title="付款"/>
                                </div>
                                <div class="details" @click="showDetails(item.orderId)">
                                    <optionsButton title="查看詳情"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page.sync="currentPage"
                        :page-sizes="[5, 10, 15]"
                        :page-size="1"
                        layout="sizes, prev, pager, next"
                        :total="orderListAction.length
                        ">
                  </el-pagination>
                </div>
            </div>
        </div>

        <!-- 订单详情对话框 --> 
        <el-dialog
            title="訂單詳情"
            :visible.sync="orderDetailsDialogVisible"
            width="50%"
            center
            :close-on-click-modal="false"
            >
            <!-- 订单信息 -->
            <div class="orderDetails">
                <div class="hd">
                    <div>
                        <span class="h">訂單編號：</span>
                        <span>{{orderDetails.number}}</span>
                    </div>
                    <div>
                        <span class="h">訂單狀態：</span>
                        <span>{{orderDetails.statusName}}</span>
                    </div>
                    <div>
                        <span class="h">金　　額：</span>
                        <!-- <span>{{orderDetails.money}}</span> -->
                        <span>{{orderDetails.realityPrice}}</span>
                    </div>
                    <div>
                        <span class="h">創辦時間：</span>
                        <span>{{orderDetails.createTime}}</span>
                        <!-- <span>{{orderDetails.startTime}}</span> -->
                    </div>
                </div>
                <div class="bd">
                    <div>
                        <span class="h">取件地址</span>
                        <span>{{orderDetails[_i18n.locale == 'en' ? 'startNameEn' : 'startName']}}</span>
                    </div>
                    <div>
                        <span class="h">取件聯係人</span>
                        <span>{{orderDetails.collectNamePhone}}</span>
                    </div>
                    <div>
                        <span class="h">收件地址</span>
                        <span>{{orderDetails[_i18n.locale == 'en' ? 'endNameEn' : 'endName']}}</span>
                    </div>
                    <div>
                        <span class="h">收件聯係人</span>
                        <span>{{orderDetails.pickingNamePhone}}</span>
                    </div>
                    <div>
                        <span class="h">收件人郵政編碼</span>
                        <span>{{orderDetails.pickingCode}}</span>
                    </div>
                    <div>
                        <span class="h">上門取件時間</span>
                        <span>{{formatDate(orderDetails.startTime)}}</span>
                    </div>
                    <div>
                        <span class="h">貨物總數</span>
                        <span>{{orderDetails.totalCount}}箱</span>
                    </div>
                    <div>
                        <span class="h">預計重量</span>
                        <span>{{orderDetails.volume}}kg</span>
                    </div>
                    <div>
                        <span class="h">預計體積重</span>
                        <span>{{orderDetails.volume}}kg</span>
                    </div>
                    <div>
                        <span class="h">預計收費重量</span>
                        <span>{{orderDetails.volume}}kg</span>
                    </div>
                    <div class="expect">
                        <span class="h">預計收費</span>
                    </div>
                    <div    v-for="item in orderDetails.orderCharges" :key="item.id">
                        <span class="h">{{item.nameCn}}</span>
                        <span>{{item.money}}USD</span>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="hanlderExport">导出Excel</el-button>
                <el-button type="primary" @click="handlerPrint">打印PDF</el-button>
            </span>
        </el-dialog>

        <!-- 付款弹出窗 -->
        <PayAlert :alertShow="payAlertShow" :callback="shutPayAlert"/>
    </div>
</template>

<script>
import optionsButton from '@/components/optionButton'
import formatDate from "@/assets/js/actionDate.js"
import PayAlert from "@/components/PayAlert/PayAlert.vue"
import NavMenu from "@/components/NavMenu.vue"
export default {
    name:'Order',
    props:["tabIndex"],
    components:{
        optionsButton,
        PayAlert,
        NavMenu
    }, 
    data(){
        return {
            // 订单列表
            orderList:[],
            // tab列表
            tabList:[
                {
                    id:'1',
                    title:'全部訂單'
                },
                {
                    id:'2',
                    title:'待收件'
                },
                {
                    id:'3',
                    title:'己收件'
                },
                {
                    id:'4',
                    title:'運送中'
                },
                {
                    id:'5',
                    title:'己送達'
                }
            ],
            // 当前激活的tab栏
            tabActive:this.$route.params.tabIndex + '',
            // 当前详情信息的对象
            orderDetails:{},
            // 控制订单对话框的展示隐藏
            orderDetailsDialogVisible:false,
            // 当前对话框的orderid
            curOrderId:0,
            payAlertShow:false,
            // 当前页数
            currentPage:0,
            // 当前页面条数
            pagesize:5,
            // 订单分页列表
            orderPagiList:[
            ],
        }
    },
    methods: {
        // 监听用户切换tab栏
        changeTab(index){
            this.tabActive = index
        },
        // 获取订单列表
        async getOrderList(){
            let res = await this.$http.get("app/order/getOrderList")
            console.log(res,'订单列表')
            if(!res.data.success) return this.$message.error("获取订单信息失败")

            this.orderList = res.data.data
            this.orderPagiList = this.createPage(this.orderListAction,this.pagesize)
        },
        // 监听用户点击查看详情
        async showDetails(id){
            this.curOrderId = id
            let orderRes = await this.$http.get("app/v2/getOrder?orderId="+id)
            console.log(orderRes,"订单详情")
            if(!orderRes.data.success) return this.$message.error("查询订单详情失败")
            // let expectRes = await this.$http.post("app/order/getOrderDetailCost?orderId="+id)
            // console.log(expectRes,"预算详情")
            // if(!expectRes.data.success) return this.$message.error("查询预算详情失败")
            // this.orderDetails = {...this.orderDetails,...res.data.data}
            
            // 对返回的数据进行加工
            let order= this.actionsOrder(orderRes.data.data)
            // 设置给vue实例对象
            this.orderDetails = order

            this.orderDetailsDialogVisible = true
        },
        // 处理后台返回的订单详情数据
        actionsOrder(orderDetails){
            console.log(orderDetails)
            // 加工后的信息
            let order = {}
            
            order = {...orderDetails.order}
            // 发件人 
            let startUser = orderDetails.orderUsers[0].typeId == 1?  orderDetails.orderUsers[0] :  orderDetails.orderUsers[1]
            // 收件人
            let endUser = orderDetails.orderUsers[0].typeId == 2?  orderDetails.orderUsers[0] :  orderDetails.orderUsers[1]
            order.collectAddress = startUser.countryCn
            order.collectNamePhone = startUser.phone
            order.pickingAddress = endUser.countryCn
            order.pickingNamePhone = endUser.phone
            order.pickingCode = endUser.code
            order.orderCharges = orderDetails.orderCharges
            order.createTime = formatDate(order.startTime).spriteDate
            order.statusName = this.checkState(order.statusId)
            console.log(this.checkState(order.statusId))
            console.log(order,"加工后的order")
            return order
        },
        // 监听用户点击支付
        pay(orderId){
            this.paid({
                orderId,
                returnPath: window.location.href
            })
            return
            this.payAlertShow = true
        },
        // 付款
        async paid(params){
            let res = await this.$http.post('/app/v2/payPage', null, {params})
            if(res.data.success){
                window.open(res.data.data)
            }
            console.log(res, '点击付款结果')
        },
        // 监听用户点击导出
        async hanlderExport(){
            let token = window.sessionStorage.getItem('token')
            this.downloadFile("订单.xlsx",`http://goods2go.com.hk/goods2go-user/app/v2/exportExcel?orderId=${this.curOrderId-0}&typeId=${0}`,token)
        },
        // 监听用户点击打印
        async handlerPrint(){
            let token = window.sessionStorage.getItem('token')
            this.downloadFile("订单.pdf",`http://goods2go.com.hk/goods2go-user/app/v2/downPDFByOrder?orderId=${this.curOrderId}&typeId=${0}`,token)
        },
        // 下载文件函数
        downloadFile(filename, fileUrl, token) {
            const xhr = new XMLHttpRequest()
            const url = fileUrl
            xhr.open('get', url, true)
            xhr.setRequestHeader('X-User', `${token}`) // 给后端发送请求头
            xhr.responseType = 'blob'
            xhr.onload = function(e) {
                if (this.status === 200) {
                    const blob = this.response
                    const urlObject = window.URL || window.webkitURL || window
                    const export_blob = new Blob([blob])
                    const a = document.createElementNS('http://www.w3.org/1999/xhtml', 'a')
                    const url = urlObject.createObjectURL(export_blob)
                    a.href = url
                    a.download = filename
                    a.click()
                }
            }
            // 发送请求
            xhr.send()

            // 查看响应
            xhr.onreadystatechange = function(){
                if(xhr.readyState == 200){
                    if(xhr.status <= 200){
                        console.log("ajax请求结果",xhr.response)
                    }
                }
            }
        },
        // 关闭支付弹出窗
        shutPayAlert(){
            this.payAlertShow = false
        },
        // 更新标题
        updateTitle(title){
            this.title = title
        },
        // 订单状态
        checkState(i){
            let state = ''
            switch(i){
                case 3:
                    state = "已提交"
                break;
                case 11:
                    state = "代收件"
                break;
                case 12:
                    state = "已收件"
                break;
                case 8:
                    state = "已送达"
                break;
            }
            return state
        },
        // 监听分页字数改变
        handleSizeChange(value){
            this.pagesize = value
            this.orderPagiList = this.createPage(this.orderListAction,value)
        },
        // 监听当前分页改变
        handleCurrentChange(value){
            this.currentPage = value
        },
        // 创建分页
        createPage(data,pagenum){
            // 可以分成的条数
            let strip = parseInt(data.length / pagenum)
            console.log(data,pagenum,strip,"数据")
            // 新数据
            let newData = []
            // 保存数据索引下标
            let index = 0
            // 循环创建每条的数据
            for(let i = 0;i <= strip;i++){
                let arr = []
                for(let j = 0;j < pagenum && index < data.length;j++){
                    arr.push(data[index])
                    index++
                }
                newData.push(arr)
            }
            return newData
        },
        // 格式化时间
        formatDate(date){
            return formatDate(date).spriteDate
        }
    },
    // 生命周期==>挂咋完毕
    mounted() {
        this.getOrderList()
    },
    computed:{
        orderListAction(){
            let newOrderList = this.orderList || []
            switch(this.tabActive + ''){
                case "2":
                    newOrderList = this.orderList.filter(item=>{
                        return item.statusName == '待收件'
                    })
                    break;
                case "3":
                    newOrderList = this.orderList.filter(item=>{
                        return item.statusName == '已收件'
                    })
                    break;
                case "4":
                    newOrderList = this.orderList.filter(item=>{
                        return item.statusName == '運送中'
                    })
                    break;
                case "5":
                    newOrderList = this.orderList.filter(item=>{
                        return item.statusName == '己送達'
                    })
                    break;    
            }
            this.orderPagiList = this.createPage(newOrderList,5)
            return newOrderList
        },
         // 标题
         title(){
            return this.$route.params.tabIndex == 1? "全部訂單":this.$route.params.tabIndex == 2? "待收件" : this.$route.params.tabIndex == 3? "己收件":this.$route.params.tabIndex == 4?"運送中": "己送達"
         },
    },
    watch:{
        // 监视路由改变
        $route(to,from){
            this.tabActive = this.$route.params.tabIndex
        },
    }
}
</script>

<style lang="less">
    #order{
        min-height: 600px;
        background-color: #F2F2F2;
        padding-top:130px;
        .body{
            &>.pubw{
                display: flex;
                justify-content:space-between;
            }
            .orderList{
                width: 72%;
                .h{
                    font-weight: 600;
                    font-size: 30px;
                    height: 56px;
                    line-height: 56px;
                    &:hover{
                        cursor: pointer;
                        opacity: .8;
                    }
                }
                .emptyTips{
                    font-size: 17px;
                    font-weight:560;
                    margin:30px 0;
                }
                .order{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    .info{
                        background-color: #fff;
                        margin: 20px 0;
                        box-shadow: 0px 2px 8px #ccc;
                        border-radius:10px;
                        width: 100%;
                        .top{
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            padding: 0 30px;
                            padding-top: 20px;
                            .orderNumber{
                                font-size:17px;
                                font-weight:600;
                                span{
                                    margin-right: 5px;
                                }
                                .number{
                                    color: @colorMain;
                                }
                            }
                            .status{
                                .submit{
                                    color: #fff;
                                    width: 100px;
                                    height: 20px;
                                    border-radius: 20px;
                                    background-color: @colorMain;
                                    padding: 3px 20px ;
                                }
                                .nosubmit{
                                    color: #fff;
                                    width: 100px;
                                    height: 20px;
                                    border-radius: 20px;
                                    background-color: #e22a2a;
                                    padding: 3px 20px ;
                                }
                            }
                        }
                        .middle{
                            margin: 30px 0;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            background-color: #f1efff;
                            padding: 30px;
                            .start,.end{
                                p{
                                    color: #ccc;
                                    text-align:center;
                                    font-size:20px;
                                }
                                p:first-child {
                                    color: #000;
                                    font-size: 30px;
                                    font-weight: 600;
                                    margin-bottom:10px;
                                }
                            }
                            .line{
                                display: flex;
                                justify-content: space-between;
                                .points{
                                    display: flex;
                                    align-items:center;
                                    margin:0 10px;
                                    span{
                                        display: inline-blcok;
                                        margin-right:3px;
                                        height: 1px;
                                        width: 5px;
                                        border: 1px solid #000;
                                    }
                                }
                                .iconfont{
                                    font-size: 30px;
                                }
                            }
                            .nopay{
                                display: inline-block;
                                color: #e22a2a;
                                font-weight:580;
                                padding: 0 10px;
                            }
                            .okpay{
                                display: inline-block;
                                color: #0cc88a;
                                font-weight:580;
                                padding: 0 10px;
                            }
                        }
                        .option{
                            display: flex;
                            justify-content: space-between;
                            align-items: space-between;
                            width: 100%;
                            height: 100%;
                            margin-top: 50px;
                            padding: 0 30px;
                            padding-bottom: 20px;
                            .pay,.details{
                                font-size: 30px;
                                color:@colorMain;
                                &:hover{
                                    cursor: pointer;
                                    opacity: .8;
                                }
                                button{
                                    width: 200px;
                                }
                            }
                            .details{
                                button{
                                    background-color: #eee;
                                    color:#878787;
                                }
                            }
                        }
                    }
                }
                .el-pagination{
                    margin-bottom: 40px;
                }
            }
        }
        .orderDetails{
            font-size: 16px;
            .hd{
                line-height: 30px;
                border-bottom: 10px solid #eee;
                padding-bottom:10px;
            }
            .bd{
                line-height: 30px;
                margin-top: 30px;
                div{
                    display: flex;
                    justify-content: space-between;
                    align-items: space-between;
                }
                .expect{
                    margin-top: 20px;
                    margin-bottom: 10px;
                    font-weight: 600;
                }
            }
        }
    }
</style>